// extracted by mini-css-extract-plugin
export var contentBody = "_da-9";
export var headerImage = "_da-2";
export var imageButton = "_da-7";
export var imageButtonIcon = "_da-8";
export var imageHeader = "_da-4";
export var imageHeaderText = "_da-5";
export var imageOverlay = "_da-3";
export var imageTitle = "_da-6";
export var imageWrapper = "_da-1";
export var taskList = "_da-a";
export var widget = "_da-0";